const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  iscompany: state => state.user.iscompany,
  info: state => state.user.info,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  role: state => state.user.roles_name,
  menu: state => state.user.menu,
  nav: state => state.user.nav,
  shareMenuButtons: state => state.user.share_menu_buttons,
  permission_routes: state => state.permission.routes,
  permissionButtonMap: state => state.permission.permissionButtonMap,
  errorLogs: state => state.errorLog.logs
}
export default getters
